// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-nav-tabs/themes/vue-tabs.scss
// module id = GFcP
// module chunks = 4